<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="editorial-rich-text" :class="{'theme-dark': isDarkTheme}">
      <sc-rich-text class="rich-text" tag="div" :field="fields.text" />
      <editorial-cta :fields="fields" />
    </div>
  </sc-render>
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
import { RichText as ScRichText } from '@sitecore-jss/sitecore-jss-vue'
import ScRender from '../sc-render'
import EditorialCta from '../editorial-cta'
import ThemeMixin from '~/mixins/theme'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'EditorialRichText',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    ScRender,
    ScRichText,
    EditorialCta
  },

  mixins: [ThemeMixin],

  computed: {
    ...mapJssGetters(['isEditMode'])
  }
}
</script>

<style lang="scss" scoped>
.editorial-rich-text {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 $space-050;
  margin-bottom: $space-090;

  @include tablet {
    padding: 0 25%;
    margin-bottom: $space-100;
  }

  .rich-text ::v-deep {
    p {
      @include font('070');
      @include stack-space($space-070);
    }

    h1, h2, h3, h4, h5 {
      font-weight: $f-weight-regular;
    }
  }

  &.theme-dark {
    .rich-text ::v-deep {
      color: $color-white;

      p, div, a {
        color: $color-white;
      }
    }
  }
}
</style>
